export { default } from './AlertContent';
